import {Presenter} from '../../../../../Support/with_presenter';
import {CalendarEvent, RsvpResponse} from '../../../../../Models/CalendarEvent';
import {Rsvp, RsvpInteractor} from '../../../../../Calendar/RsvpInteractor';
import {Subscription} from 'rxjs';

export class RsvpResponseCellPresenter implements Presenter {
    public get response(): RsvpResponse {
        return (
            this.rsvps.find((rsvp) => {
                return (
                    rsvp.userId === this.userId &&
                    rsvp.scheduledEventId === this.calendarEvent.scheduledEventId &&
                    rsvp.startsAt.getTime() === this.calendarEvent.startAt.getTime()
                );
            })?.rsvpResponse ?? RsvpResponse.Unknown
        );
    }

    private rsvps: Rsvp[] = [];
    private subscription: Subscription | undefined;

    constructor(private userId: number, private calendarEvent: CalendarEvent, private rsvpInteractor: RsvpInteractor) {}

    public mount(): void {
        this.subscription = this.rsvpInteractor.rsvps.subscribe((rsvps) => {
            this.rsvps = rsvps;
        });
    }

    public unmount(): void {
        this.subscription?.unsubscribe();
    }

    public async toggle(): Promise<void> {
        await this.rsvpInteractor.reply(
            this.calendarEvent.scheduledEventId,
            this.userId,
            this.calendarEvent.startAt,
            this.nextResponse(),
        );
    }

    private nextResponse(): RsvpResponse {
        switch (this.response) {
            case RsvpResponse.Yes:
                return RsvpResponse.No;
            case RsvpResponse.No:
                return RsvpResponse.Maybe;
            case RsvpResponse.Maybe:
                return RsvpResponse.Yes;
            case RsvpResponse.Unknown:
                return RsvpResponse.Yes;
        }
    }
}
